import { render, staticRenderFns } from "./PremiumMembershipRequired.vue?vue&type=template&id=687f7d40&scoped=true"
import script from "./PremiumMembershipRequired.vue?vue&type=script&lang=js"
export * from "./PremiumMembershipRequired.vue?vue&type=script&lang=js"
import style0 from "./PremiumMembershipRequired.vue?vue&type=style&index=0&id=687f7d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f7d40",
  null
  
)

export default component.exports